import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsRelationsPresseStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsRelationsPresse'
const customImplement: CustomStoreImplementationOptions = formationsRelationsPresseStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsRelationsPresseFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-09-relations-presse.title', 'Formation en relations presse sur-mesure'),
        $description: $translate('prog-09-relations-presse.description', 'Offrez plus de visibilité à votre entreprise et gérez vos relations publiques en vous formant sur-mesure aux relations presse avec un expert Matchers ! '),
        $publishedTime: new Date('2023-02-13T07:42:17.622Z'),
        $modifiedTime: new Date('2023-09-15T08:03:37.543Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Communication institutionnelle' },
            { Nom: 'Media training' },
            { Nom: 'Rédaction' },
            { Nom: 'Blog' },
            { Nom: 'Brand content' },
            { Nom: 'Médias sociaux' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Medias off & on line' },
            { Nom: 'Partenariats' },
            { Nom: 'Communication de crise' },
            { Nom: 'Ciblage' },
            { Nom: 'Communication interne' },
            { Nom: 'Influence' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Médias et audiovisuel' },
            { Nom: 'Rédaction' },
            { Nom: 'Content marketing' },
            { Nom: 'Brand content' },
            { Nom: 'Relations publiques' },
            { Nom: 'Événementiel' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Savoir identifier les médias correspondant à ses cibles.</li></ul>' },
            { Text: '<ul><li>Connaître le panorama des pure players.</li></ul>' },
            { Text: '<ul><li>Proposer des contenus attractifs et pertinents.</li></ul>' },
            { Text: '<ul><li>Être en mesure d’harmoniser ses communiqués de presse pour mettre en avant sa proposition de valeur en fonction de l’audience du journaliste visé.</li></ul>' },
            { Text: '<ul><li>Savoir documenter son sujet pour répondre aux exigences journalistiques.</li></ul>' },
            { Text: '<ul><li>Maîtriser les techniques de storytelling pour capter l’attention des journalistes.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Fidéliser les journalistes en devenant une source d’information précieuse.</li></ul>' },
            { Text: '<ul><li>Savoir mettre en place un plan annuel relations presse dans le but d’optimiser son temps et ses contacts.</li></ul>' },
            { Text: '<ul><li>Animer sa sphère d’influence et son réseau grâce à la communication de proximité (événements, téléphone, emails).</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Identifier les profils susceptibles de gérer les RP au sein de son organisation.</li></ul>' },
            { Text: '<ul><li>Préparer ses équipes à donner des interviews (bonnes pratiques et pièges à éviter).</li></ul>' },
            { Text: '<ul><li>Savoir organiser et conduire une conférence de presse.</li></ul>' },
            { Text: '<ul><li>Savoir gérer une situation de crise en anticipant les questions posées sur des sujets sensibles.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $info: { prog09RelationsPresse: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/622', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element2Click () {
        openUrl('https://www.matchers.fr/expert/623', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element3Click () {
        openUrl('https://www.matchers.fr/expert/220', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsRelationsPresseFactory(storeId)()
}

export const formationsRelationsPresseRaw = formationsRelationsPresseFactory()
export const formationsRelationsPresse = () => formationsRelationsPresseRaw() as MergeCustomStore<typeof formationsRelationsPresseStoreCustom.instance>
